import { api } from '@/api';

export default {
  namespaced: true,
  state: {
    activityLogs: [],
  },
  mutations: {
    setActivityLogs(state, value) {
      state.activityLogs = value;
    },
  },
  actions: {
    async getCrmPlanActivityLogs({ commit, store }, { id, ...params }) {
      if (!params.actionCategory) {
        commit('setActivityLogs', []);
        return [];
      }
      const response = await api.getCrmPlanActivityLogs(id, {
        ...params,
      });
      const responseData = response.data;
      commit('setActivityLogs', responseData);
      return responseData;
    },
  },
};
